// extracted by mini-css-extract-plugin
export var cardContainer = "locationCard-module--card-container--1z9jg";
export var cardTitle = "locationCard-module--card-title--3VZHc";
export var gmapLink = "locationCard-module--gmap-link--21Y0n";
export var address = "locationCard-module--address--1i-kQ";
export var phone = "locationCard-module--phone--82H3M";
export var hoursContainer = "locationCard-module--hours-container--2J31y";
export var shopButton = "locationCard-module--shop-button--1yfRA";